import { Marker } from 'react-leaflet';
import L, { LeafletMouseEvent } from 'leaflet';
import { LargeInfoBoxTooltip } from '../ToolTips/LargeInfoBoxTooltip';
import SmallInfoBoxTooltip from '../ToolTips/SmallInfoBoxTooltip';
import useDevice from 'hooks/useDevice';
import { useMapStore, useRootStore } from 'contexts/RootStore.context';
import { Asset } from 'types/asset';
import useMap from 'views/map/hooks/useMap';
import { observer } from 'mobx-react';
import { getIconFromEstimateFreshness } from 'views/map/utils/utils';

export const AssetMarker = observer(({ asset }: { asset: Asset }) => {
  const { freshPeriodThresholdSeconds } = useRootStore()
  const { filterForm, selectBeacon, selectedBeaconId,
    // to force re-render on map move and show the tooltips
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    mapMoveVersion
  } = useMapStore()
  const { panToLatLong, isMarkerVisible } = useMap(useMapStore());
  const { isMobileDevice } = useDevice();

  const isAssetSelected = selectedBeaconId === asset.assigned_beacon!.id;

  const markerLong = asset.location.coordinates.longitude;
  const markerLat = asset.location.coordinates.latitude;

  function handleMarkerClick(e: LeafletMouseEvent, asset: Asset) {
    selectBeacon(asset.assigned_beacon!.id);
    panToLatLong(e.latlng);
  }

  const customIcon = new L.Icon({
    iconUrl: getIconFromEstimateFreshness(asset, freshPeriodThresholdSeconds),
    iconSize: new L.Point(20, 20),
    iconAnchor: [10, 10], // half of icon size.
    className: 'leaflet-custom-icon',
  });

  function handleCloseInfoBox() {
    selectBeacon(null);
  }

  return (
    <Marker
      title={`${asset.asset_name}`}
      eventHandlers={{
        click: (e) => {
          handleMarkerClick(e, asset);
        },
      }}
      icon={customIcon}
      position={[markerLat, markerLong]}
    >
      {isAssetSelected && !isMobileDevice && (
        <LargeInfoBoxTooltip asset={asset} handleCloseInfoBox={handleCloseInfoBox} />
      )}
      {filterForm.$.displayAssetName.value && !isAssetSelected && isMarkerVisible(asset) &&
        <SmallInfoBoxTooltip asset={asset} />}
    </Marker>
  );
})
